/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Task/UpdateRequests
 */
export interface UpdateRequestsRequestBuilder extends BaseRequestBuilder<UpdateRequestsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<UpdateRequestsRequestBuilderPostQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<UpdateRequestsRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface UpdateRequestsRequestBuilderPostQueryParameters {
    lastUpdateAgeInMinutes?: number;
}
/**
 * Uri template for the request builder.
 */
export const UpdateRequestsRequestBuilderUriTemplate = "{+baseurl}/Task/UpdateRequests?lastUpdateAgeInMinutes={lastUpdateAgeInMinutes}";
/**
 * Metadata for all the requests in the request builder.
 */
export const UpdateRequestsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: UpdateRequestsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
